"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Repository = /** @class */ (function () {
    function Repository() {
    }
    return Repository;
}());
exports.Repository = Repository;
//# sourceMappingURL=Repository.js.map